import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestUpdates from "@/pages/home/components/LatestUpdates";
import HotRanking from "@/pages/home/components/HotRanking";

export default function Home() {
  return (
    <div className="w-full">
      <HeroCarousel />

      <CategoryEntries />

      <section className="w-full px-4 md:px-8 pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-6 lg:gap-8">
          <LatestUpdates />

          <div className="space-y-6">
            <HotRanking />

            <div className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg p-5 text-background-50">
              <h3 className="font-heading font-extrabold text-lg flex items-center gap-2">
                <i className="ri-tv-2-line"></i>
                关于本站
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-background-50/90">
                「动漫免费在观看」致力于为动漫爱好者提供丰富多样的高清动漫资源，涵盖热门新番与经典作品，支持在线播放与收藏，随时随地享受流畅观影体验。
              </p>
              <Link
                to="/about"
                className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-background-50 text-primary-700 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-lg p-5">
              <h3 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
                <i className="ri-information-line text-secondary-500"></i>
                演示说明
              </h3>
              <ul className="mt-3 space-y-2.5 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>播放器为前端演示控件，无真实视频流</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>收藏记录保存在本地，刷新后仍然保留</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-line text-primary-500 mt-0.5"></i>
                  <span>全部数据为前端演示内容</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}